module.exports = __webpack_public_path__ + "img/1482133948357.8b9ba25d.jpg";